import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './showPresenceDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { ChildsSlots, StaffSlots } from '@/types/StaffRate'
import { ChildCareOutlined } from '@mui/icons-material'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface ShowPresenceDialogProps {
    isDialogOpen: boolean
    handleCloseDialog: () => void
    childs: ChildsSlots[]
    staffs: StaffSlots[]
    start: string
    end: string
}

const ShowPresenceDialog: FunctionComponent<ShowPresenceDialogProps> = ({
    isDialogOpen,
    handleCloseDialog,
    childs,
    staffs,
    start,
    end
}: ShowPresenceDialogProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    return (
        <Dialog open={isDialogOpen} handleClose={handleCloseDialog} className={styles.Dialog}>
            <DialogHeader title={start + ' - ' + end} />
            <DialogBody className={styles.DialogBody}>
                {childs.length > 0 && (
                    <TableContainer className={styles.TablePlacement}>
                        <Table className={styles.Table}>
                            <TableHead className={styles.TableHeader}>
                                <TableRow>
                                    <TableCell colSpan={2}>{t('childList')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[...childs]
                                    .sort((a: ChildsSlots, b: ChildsSlots) => a.childName.localeCompare(b.childName))
                                    .map((childSlot: ChildsSlots, index: number) => (
                                        <TableRow key={childSlot.childId + '-' + index}>
                                            <TableCell className={styles.TextIcon}>
                                                <ChildCareOutlined
                                                    onClick={() => navigate('/childs?child=' + childSlot.childId)}
                                                    className={styles.Icon}
                                                />
                                                <p className={styles.Text}>{childSlot.childName}</p>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {staffs.length > 0 && (
                    <TableContainer className={styles.TablePlacement}>
                        <Table className={styles.Table}>
                            <TableHead className={styles.TableHeader}>
                                <TableRow>
                                    <TableCell>{t('staffList')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[...staffs]
                                    .sort((a: StaffSlots, b: StaffSlots) => a.staffName.localeCompare(b.staffName))
                                    .map(({ staffName }, index: number) => (
                                        <TableRow key={index}>
                                            <TableCell>{staffName}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleCloseDialog} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ShowPresenceDialog
